<div class="signup-login" *ngIf="show">
    <div *ngIf="state === 'display'">
        <form id="login" *ngIf="mode === 'login'" [formGroup]="loginForm" (onSubmit)="login()" (keyup.enter)="login()">
            <div class="bold">Welcome Back</div>
            <div class="subtext">Log in for easy checkout</div>
            <label for="login-email">Email</label>
            <input id="login-email" type="text" name="email" formControlName="email" required>
            <label for="login-password">Password</label>
            <input id="login-password" type="password" name="password" formControlName="password" (blur)="login()" (keyup.enter)="login()"  required>
            <div class="flex subtext">
                <div class="flex-grow-1">
                    <button class="btn invert sm-square" (click)="login()">Login</button>
                </div>
                <div>Don't have an account?&nbsp;</div>
                <div class="underline" (click)="mode = 'signup'">Signup now</div>
            </div>
            <!-- <div class="subtext">Don't have an account? <div class="underline" (click)="mode = 'signup'">Sign Up</div></div> -->
        </form>
        <form id="signup" *ngIf="mode === 'signup'" [formGroup]="signupForm"  (onSubmit)="signup()">
            <div class="flex">
                <div class="bold">Create Account</div>
                <i *ngIf="subscription; else optional">&nbsp;(Required if you are signing up for a membership)</i>
                <ng-template #optional>
                    <i>&nbsp;(Optional)</i>
                </ng-template>
            </div>
            <label for="username">Email</label>
            <input 
                id="username" 
                type="email" 
                name="email" 
                formControlName="email" 
                required 
            >
            <label for="signup-password">Create Password</label>
            <input 
                id="signup-password" 
                type="password" 
                name="password" 
                formControlName="password" 
                required 
                (keyup.enter)="signup()" 
                minlength="8"
            >
            <span class="error" *ngIf="signupError">{{signupError}}</span>
            <div class="flex">
                <div class="flex-grow-1">
                    <button class="btn invert sm-square" (click)="signup()">Create Account</button>
                </div>
                
                <div class="flex subtext" style="font-size: 12px">
                    <div>Already have an account?&nbsp;</div>
                    <div class="underline" (click)="mode = 'login'">Login Now</div>
                </div>
            </div>
            
        </form>
    </div>
    <div *ngIf="state === 'success'">
        <div class="bold">Success!</div>
        <div class="subtext">You are now logged in</div>
    </div>
    <div *ngIf="state === 'inProgress'">
        <div class="bold">{{ progressMessage }}</div>
    </div>
    <div *ngIf="state === 'finished'">
        <div *ngIf="mode === 'signup'">
            <div class="bold">Success!</div>
            <div class="subtext">Account created and logged in with {{ signupForm.get('email').value }}</div>
        </div>
        <div *ngIf="mode === 'login'">
            Welcome back, {{ _user?.firstName }}!
        </div>
    </div>
    <div *ngIf="state === 'error'" class="flex">
        <div class="flex-grow-1">{{ error }}</div> 
        <button class="btn btn-sm" (click)="confirmError()">Ok</button>
    </div>
</div>
